
// Webapp Verion
export var Version = "1.0";

//notifications
export const SUBSCRIPTION_STATES = {
    ACCEPTED:"accepted",
    REJECTED:"rejected",
    BANNED:"banned",
}
